import React, {useEffect, useState} from "react";
import Tab from "./Tab";
import { inject, observer } from "mobx-react";

const generateProgressStyle = (currentCount, totalCount, isLoading) => {
  if (!isLoading || currentCount === undefined || totalCount === undefined || currentCount === totalCount) {
    return null;
  } else {
    const ratio = totalCount > 0 ? currentCount / totalCount : 1;
    return {
      background: `linear-gradient(270deg, #BCBABA ${Math.floor(
        100 - ratio * 100
      )}%, #676161 ${Math.floor(ratio * 100)}%)`
    };
  }
};

const TabBar = ({searchSessionStore}) => {
  const {
    tabs,
    awaitingInitialResults,
    retainResultsLayout,
    isLoading,
    downloadedResults,
    categoryTotals,
    currentCategory,
    firstNonemptyCategory,
  } = searchSessionStore;

  const onTabSelect = (key) => {
    if (key !== "graph" && !categoryTotals.get(key)) {
      key = firstNonemptyCategory;
    }
    if (key) {
      searchSessionStore.currentCategory = key;
    }
  }

  return (
      <ul className={`custom-nav-bar tab-bar${awaitingInitialResults && !retainResultsLayout ? ' loading' : ''}`}>
        {(!awaitingInitialResults || retainResultsLayout) && tabs.map(tab => {
          const downloadedCount = downloadedResults.get(tab.key)?.length;
          const totalCount = categoryTotals.get(tab.key);
          const {key, disabled, ...tabProps} = tab;
          // Category tabs (not graph) with undefined totalCount should be disabled
          const isDisabled = disabled || (key !== "graph" && totalCount === undefined);
          return (
            <li key={key}>
              <div className="tab-progress" style={generateProgressStyle(downloadedCount, totalCount, isLoading)} />
              <Tab
                {...tabProps}
                downloadCount={downloadedCount}
                totalCount={totalCount}
                onClick={() => onTabSelect(tab.key)}
                isActive={key === currentCategory}
                disabled={isDisabled}
              />
            </li>
          )
        })}
      </ul>
  );
};

export default inject("searchSessionStore")(observer(TabBar));
